import { render, staticRenderFns } from "./WxMessageRecored.vue?vue&type=template&id=4a6a784f&scoped=true&"
import script from "./WxMessageRecored.vue?vue&type=script&lang=js&"
export * from "./WxMessageRecored.vue?vue&type=script&lang=js&"
import style0 from "./WxMessageRecored.vue?vue&type=style&index=0&id=4a6a784f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6a784f",
  null
  
)

export default component.exports